import React from "react";
import { tv } from "tailwind-variants";
import type { VariantProps } from "tailwind-variants";

import { getRoleLabel, Role, ROLES } from "~/shared.types";
import { icons } from "~/ui";

const userTypeButtonVariants = tv({
  base: "flex items-center max-w-60 w-full justify-between gap-2 rounded-md border-1 px-4 py-2 text-md font-light transition-all text-indigo",
  variants: {
    userType: {
      [ROLES.SUPER_ADMIN.value]: "bg-poppyRed/10 border-poppyRed",
      [ROLES.ADMIN.value]: "bg-yellow/10 border-yellow",
      [ROLES.STAFF.value]: "bg-green/20 border-green",
      [ROLES.USER.value]: "bg-violet/10 border-violet",
    },
    clickable: {
      true: "cursor-pointer hover:opacity-80",
    },
  },
  defaultVariants: {
    clickable: false,
  },
});

interface UserTypeButtonProps extends VariantProps<
  typeof userTypeButtonVariants
> {
  userType: Role;
  onClick?: () => void;
  disabled?: boolean;
}

export const UserTypeButton = ({
  userType,
  onClick,
  disabled = false,
}: UserTypeButtonProps) => {
  const isClickable = !disabled;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={userTypeButtonVariants({
        userType,
        clickable: isClickable,
      })}
    >
      <span>{getRoleLabel(userType)}</span>
      {isClickable && (
        <icons.outline.ChevronRightIcon className="stroke-3 h-5 w-5 text-gray-400" />
      )}
    </button>
  );
};
